import React from 'react';
import {
  Skeleton as MUISkeleton,
  SkeletonProps as MUISkeletonProps,
} from '@mui/material';

export const Skeleton = (props: MUISkeletonProps) => <MUISkeleton {...props} />;
